import React, { useEffect } from 'react';
import { Container, Row, Col, Image, Stack } from 'react-bootstrap';
import { logBlogView, useBlogDetailsQuery, useBlogsQuery } from 'services';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import parse from 'html-react-parser';
import { buildBlogApiUrl } from 'utils';
import Blog from 'components/Blog';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';

export const BlogDetail: React.FC = () => {
	const { id } = useParams<string>();
	const { translate } = useTranslate();
	const {
		data: {
			data: {
				attributes: {
					Title: title = '',
					publishedAt = '',
					Description: description = '',
					Image: imageList = [],
					category: categoryList = [],
				} = {},
			} = {},
		} = {},
	} = useBlogDetailsQuery(id);

	const { attributes: category = {} } = categoryList?.data || [];

	const image = imageList?.data
		? {
				id: imageList?.data?.id,
				attributes: {
					name: imageList?.data?.attributes?.name,
					hash: imageList?.data?.attributes?.hash,
					url: imageList?.data?.attributes?.formats?.large?.url,
				},
			}
		: null;

	const { data: { data: featuredBlogList = [] } = {} } = useBlogsQuery(
		buildBlogApiUrl(1, { featuredBlog: 1, blogIdNotEqual: id }, '5'),
	);

	useEffect(() => {
		if (id) {
			logBlogView(id);
		}
	}, []);

	return (
		<section className="static-page bg-white">
			<Container>
				<div className="blog-detail py-50">
					<Row>
						<Col
							lg={featuredBlogList?.length > 0 ? 4 : 0}
							md={featuredBlogList?.length > 0 ? 5 : 0}
						>
							<Stack className="recent-blogs gap-4">
								<h4 className="fw-bold">{translate('Extras.featuredBlogPosts')}</h4>
								{featuredBlogList?.length > 0 &&
									featuredBlogList?.map((featured: any, index: number) => (
										<Blog key={index} blog={featured} />
									))}
							</Stack>
						</Col>
						<Col
							lg={featuredBlogList?.length > 0 ? 8 : 12}
							md={featuredBlogList?.length > 0 ? 7 : 12}
						>
							<div className="blog-card">
								{publishedAt && (
									<h6 className="fw-bold mb-2">{moment(publishedAt).format('D MMM YYYY')}</h6>
								)}
								{title && <h3 className="fw-bold mb-3 mb-md-4">{title}</h3>}
								{image?.attributes?.url && (
									<div className="mb-3 mb-md-4">
										<Image
											src={image.attributes.url}
											alt="blog-img"
											className="w-100 h-100 object-fit-cover"
											loading="lazy"
										/>
									</div>
								)}
								<Stack className="blog-detail-content">
									{category?.Name && (
										<div className="blog-info d-flex flex-wrap gap-2 mb-4">
											<div className="blog-info-box">{category.Name}</div>
										</div>
									)}
									<div>{description && <p>{parse(description.replace(/\n/g, '<br />'))}</p>}</div>
								</Stack>
							</div>
						</Col>
					</Row>
				</div>
			</Container>
		</section>
	);
};

export default BlogDetail;
